import './table-tree-view.css';
export default {
  "button": "pf-v6-c-button",
  "dirRtl": "pf-v6-m-dir-rtl",
  "modifiers": {
    "treeView": "pf-m-tree-view",
    "noInset": "pf-m-no-inset",
    "treeViewGrid": "pf-m-tree-view-grid",
    "borderRight": "pf-m-border-right",
    "treeViewDetailsExpanded": "pf-m-tree-view-details-expanded",
    "treeViewGridMd": "pf-m-tree-view-grid-md",
    "treeViewGridLg": "pf-m-tree-view-grid-lg",
    "treeViewGridXl": "pf-m-tree-view-grid-xl",
    "treeViewGrid_2xl": "pf-m-tree-view-grid-2xl"
  },
  "table": "pf-v6-c-table",
  "tableAction": "pf-v6-c-table__action",
  "tableCheck": "pf-v6-c-table__check",
  "tableTbody": "pf-v6-c-table__tbody",
  "tableTd": "pf-v6-c-table__td",
  "tableTh": "pf-v6-c-table__th",
  "tableThead": "pf-v6-c-table__thead",
  "tableToggle": "pf-v6-c-table__toggle",
  "tableToggleIcon": "pf-v6-c-table__toggle-icon",
  "tableTr": "pf-v6-c-table__tr",
  "tableTreeViewDetailsToggle": "pf-v6-c-table__tree-view-details-toggle",
  "tableTreeViewIcon": "pf-v6-c-table__tree-view-icon",
  "tableTreeViewMain": "pf-v6-c-table__tree-view-main",
  "tableTreeViewText": "pf-v6-c-table__tree-view-text",
  "tableTreeViewTitleCell": "pf-v6-c-table__tree-view-title-cell"
};